import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Card = styled(Box)(({ theme }) => ({
  backgroundColor: theme.customColors.backgroundCard,
  borderRadius: "20px",
  padding: "32px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  border: `1px solid ${theme.customColors.border}`
}));

export const DialogTitle = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontWeight: 700,
  fontSize: "1.5rem"
}));

export const RatingRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
  flexWrap: "wrap"
}));

export const RatingLabel = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem"
}));

type RatingButtonProps = { selected: boolean };

export const RatingButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "selected"
})<RatingButtonProps>(({ theme, selected }) => ({
  width: "2rem",
  height: "2rem",
  borderRadius: "50%",
  fontSize: "1rem",
  color: selected ? theme.customColors.textPrimaryCta : theme.customColors.exploreCardText,
  backgroundColor: selected ? theme.customColors.backgroundPrimaryCta : theme.customColors.backgroundPrimaryControl,
  "&:hover": {
    backgroundColor: selected ? theme.customColors.accentVariantA :  theme.customColors.backgroundSecondaryCtaHover
  },
  transition: "none !important"
}));

export const CommentArea = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.customColors.backgroundSecondary,
    border: `1x solid ${theme.customColors.border}`,
    padding: "1rem",
    borderRadius: "0.5rem",
    fontSize: "0.75rem",
    color: theme.customColors.textInput,
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": { border: "none" }
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.customColors.textInput,
    opacity: 1
  }
}));

export const DialogActionsRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  gap: "12px",
  marginTop: "8px"
}));

export const CancelButton = styled(Button)(() => ({
  backgroundColor: "transparent",
  color: "#ffffff",
  border: "1.5px solid #ffffff",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  padding: "8px 24px",
  minWidth: "110px",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
    borderColor: "#ffffff"
  }
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.customColors.backgroundCard,
  color: "#000000",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: "14px",
  padding: "8px 24px",
  minWidth: "110px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.customColors.backgroundCard,
    boxShadow: "none"
  },
  "&.Mui-disabled": {
    backgroundColor: "#3a3a3a",
    color: "#777777"
  }
}));
